import React from 'react';
interface UmlLogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}
/**
 * Recreation of the United Mortgage Lending logo.
 * "UNITED MORTGAGE" in brand orange, "LENDING" beneath in tracked thin letters,
 * all bounded by a thin rectangular border.
 */
export function UmlLogo({
  className = '',
  variant = 'light'
}: UmlLogoProps) {
  const borderColor = variant === 'dark' ? '#ffffff33' : '#1a1a1a';
  const lendingColor = variant === 'dark' ? '#ffffff' : '#1a1a1a';
  return <div className={`inline-flex flex-col items-center justify-center px-3 py-1.5 border ${className}`} style={{
    borderColor
  }} data-id="element-307">
      <div className="font-sans font-bold leading-none" style={{
      color: '#F26522',
      fontSize: '0.95em',
      letterSpacing: '0.02em'
    }} data-id="element-308">
        UNITED MORTGAGE
      </div>
      <div className="font-sans font-light leading-none mt-0.5" style={{
      color: lendingColor,
      fontSize: '0.55em',
      letterSpacing: '0.45em',
      paddingLeft: '0.45em' // offset to balance the letter-spacing
    }} data-id="element-309">
        LENDING
      </div>
    </div>;
}